export interface ToggleProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  label?: string;
  disabled?: boolean;
}

export function Toggle({ checked, onChange, label, disabled }: ToggleProps) {
  return (
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: 8, cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
        aria-checked={checked}
      />
      <span
        aria-hidden
        style={{
          // עיצוב v2: 46×28, ידית 22. דלוק = הידית בתחילת השורה (ימין
          // ב-RTL), כמו בכרטיסי הקמפיין בעיצוב.
          flex: 'none',
          width: 46,
          height: 28,
          borderRadius: 'var(--r-pill)',
          background: checked ? 'var(--accent)' : 'var(--surface-3)',
          border: '1px solid ' + (checked ? 'transparent' : 'var(--glass-line-2)'),
          position: 'relative',
          opacity: disabled ? 0.5 : 1,
          transition: 'background 160ms ease',
        }}
      >
        <span
          style={{
            position: 'absolute',
            top: 2,
            insetInlineStart: checked ? 2 : 20,
            width: 22,
            height: 22,
            borderRadius: '50%',
            background: '#fff',
            boxShadow: '0 1px 3px rgba(0,0,0,.18), 0 2px 6px rgba(0,0,0,.08)',
            transition: 'inset-inline-start 220ms cubic-bezier(.3,1.35,.4,1)',
          }}
        />
      </span>
      {label && <span style={{ fontSize: 'var(--t-sm)' }}>{label}</span>}
    </label>
  );
}
